export function showPictureAtVideoError(videoNode) {
    const playbackId = videoNode.getAttribute('playback-id');
    console.error(`Error loading video with playbackId: ${playbackId}`);

    let videoParent = videoNode.parentNode
    if(videoParent.classList.contains('content-platform__video-container')) {
        videoNode = videoParent;
        videoParent = videoParent.parentNode;
    }

    //remove video
    videoParent.removeChild(videoNode);

    //toggle picture display property class
    for (const element of videoParent.querySelectorAll('.content-platform__hidden-for-video')) {
        element.classList.remove('content-platform__hidden-for-video');
    }
}

